/* eslint-disable import/no-anonymous-default-export */
export default (adminStats = [], action) => {
  switch (action.type) {
    case "GET_ALL_ADMINISTRATOR_STATS":
      return action.payload;

    default:
      return adminStats;
  }
};
